import { render, staticRenderFns } from "./ArchivedTenderPlug.vue?vue&type=template&id=27672f16&"
import script from "./ArchivedTenderPlug.vue?vue&type=script&lang=js&"
export * from "./ArchivedTenderPlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports